"use client";

import "@/styles/components/searchbar.scss";

export default function SearchBar({ value = "", onChange, onSearch }) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") onSearch?.(value);
  };

  return (
    <div className="search_bar">
      <span className="search_icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2.2"
          strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"/>
          <line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
      </span>

      <input
        type="text"
        placeholder="Search items that cannot be shipped"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        onKeyDown={handleKeyDown}
      />

      {/* Clear button — only shown when there's a query */}
      {value && (
        <button
          className="clear_btn"
          onClick={() => { onChange?.(""); onSearch?.(""); }}
          aria-label="Clear search"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.5"
            strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      )}

      <button
        className="search_btn"
        onClick={() => onSearch?.(value)}
        aria-label="Search"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2.5"
          strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"/>
          <line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <span>Search</span>
      </button>
    </div>
  );
}